export default __webpack_public_path__ + "static/media/storageUnit1-beforeB-480w.3df13000.avif";